import { Theme } from '@mui/material/styles';

export default function FormControlLabel(theme: Theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '&:has(.MuiSwitch-root)': {
            marginLeft: 0,
            marginRight: 0,
            gap: theme.spacing(1.25),
          },
        },
      },
    },
  };
}
